export default __webpack_public_path__ + "static/media/main_logo.a799f1d4.PNG";